import React, {useEffect, useState} from 'react';
import {useNavigate} from "react-router-dom";
import Requests from "../components/Requests";


const RequestsListPage = () => {
    const navigate = useNavigate();
    const [showPage, setShowPage] = useState(false);

    useEffect(() => {

        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;

        if(token) {
            if(window.localStorage.getItem("needRegistration") === '1'){
                navigate('/register');
            }
            setShowPage(true)

        }
        else {
            localStorage.setItem('redirectAfterLogin', window.location.pathname);
            localStorage.setItem('redirectAfterLogin', window.location.pathname);
            navigate('/unauthorize', { replace: true });
        }

    }, []);
    return (
        <React.Fragment >
            {showPage ?
                <Requests />
                : ''
            }

        </React.Fragment>
    );
};

export default RequestsListPage;